/**
 * `InfoPopover` (W1-12 ui-kit-i18n; contract InfoPopoverProps, DESIGN.md §2.5, §4.11): the small (i) button
 * next to a label. It opens a popover with one sentence, the RPE term and the community (Chinese) term, and an
 * optional looping illustration (internal/Illustration.tsx). Keyboard: Enter / Space open it, Escape closes it
 * and returns focus to the button.
 */

import { useT } from '../i18n/useT';
import { useTr } from './bridge';
import { IconButton } from './IconButton';
import s from './InfoPopover.module.css';
import { Illustration } from './internal/Illustration';
import { Popover } from './Popover';
import type { InfoPopoverProps } from './types';
import { m } from './ui.messages';

export function InfoPopover(props: InfoPopoverProps) {
  const t = useT();
  const tr = useTr();
  return (
    <Popover
      trigger={<IconButton icon="Info" label={{ key: m.moreInfo }} size="sm" className={s.trigger} />}
      side="right"
      align="start"
      label={t(m.moreInfo)}
      contentClassName={s.content}
    >
      <p className={s.text}>{tr(props.text)}</p>
      {(props.rpeTerm !== undefined || props.communityTerm !== undefined) && (
        <ul className={s.terms} role="list">
          {props.rpeTerm !== undefined && <li>{t(m['info.rpe'], { term: props.rpeTerm })}</li>}
          {props.communityTerm !== undefined && (
            <li lang="zh-CN">{t(m['info.community'], { term: props.communityTerm })}</li>
          )}
        </ul>
      )}
      {props.illustration !== undefined && <Illustration id={props.illustration} />}
    </Popover>
  );
}
